'use client';

import { useEffect, useState } from 'react';

import { LocalizedRoutes } from '@ravago/shared/page-data/models/pages';

import dynamic from 'next/dynamic';
import { CookiesProvider } from 'react-cookie';

import type { RegionModalData } from './utils/region-modal.utils';
import { regionCookieOptions } from './utils/region-preference.utils';

const RegionModal = dynamic(() => import('./region-modal').then((mod) => mod.RegionModal), {
  ssr: false
});

interface Props extends RegionModalData {
  currentCountry: string;
  currentLanguage: string;
  localizedRoutes?: LocalizedRoutes;
}

const DELAY_MS = 4_000;

const RegionModalTriggerInner = (props: Props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setOpen(true), DELAY_MS);

    return () => clearTimeout(timeout);
  }, []);

  if (!open) return null;

  return <RegionModal {...props} open={open} onClose={() => setOpen(false)} />;
};

export const RegionModalTrigger = (props: Props) => (
  <CookiesProvider defaultSetOptions={regionCookieOptions}>
    <RegionModalTriggerInner {...props} />
  </CookiesProvider>
);

export default RegionModalTrigger;
